import styled from 'styled-components';

const Wrapper = styled.div`
  padding-bottom: 20px;
  top: 0;
  left: 0;
  z-index: -1;
  height: 100vh;
  min-height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

export default Wrapper;
